import { FormControl, InputLabel, MenuItem, Select, type SelectChangeEvent } from '@mui/material';

import { SPREAD_LIST, type SpreadKey } from '@/data/spreads';

import { spreadSelectorFormControlSx } from './SpreadSelector.styles';

interface Props {
  value: SpreadKey;
  onChange: (key: SpreadKey) => void;
}

function SpreadSelector({ value, onChange }: Props) {
  const handleChange = (event: SelectChangeEvent<SpreadKey>) => {
    onChange(event.target.value as SpreadKey);
  };

  return (
    <FormControl sx={spreadSelectorFormControlSx}>
      <InputLabel id="spread-label">Spread Type</InputLabel>
      <Select<SpreadKey>
        labelId="spread-label"
        label="Spread Type"
        value={value}
        onChange={handleChange}
        aria-label="Select tarot spread type"
      >
        {SPREAD_LIST.map((spread) => (
          <MenuItem key={spread.key} value={spread.key}>
            {spread.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default SpreadSelector;
